import React, { useState } from 'react';
import { NavLink, Outlet } from 'react-router-dom';
import styles from './stats.module.scss';
import { useGetStatsList } from '~/hooks/stats';
import FilterSearchParam from '~/components/FilterSearchParam';
import ButtonExport from '~/components/ButtonExport';
import { downloadStatsXlsx } from '~/utils/index';

const Statistiques = () => {
  const { data: list = { } } = useGetStatsList();
  const [isDownloadingXlsx, setIsDownloadingXlsx] = useState(false);

  const handleDownloadXlsx = async () => {
    try {
      setIsDownloadingXlsx(true);
      await downloadStatsXlsx();
    } finally {
      setIsDownloadingXlsx(false);
    }
  };

  return (
  <div className={styles.stats}>
    <div className={styles.content}>
      <header>
        <h1>Statistiques</h1>
        <div className={styles.filters}>
          <div className={styles.toggles}>
            <NavLink
              to="inscriptions"
              className={({ isActive }) => `${styles.tab} ${isActive ? styles.activeTab : ''}`}
            >
              Inscriptions
            </NavLink>
            <NavLink
              to="salon"
              className={({ isActive }) => `${styles.tab} ${isActive ? styles.activeTab : ''}`}
            >
              Salon
            </NavLink>
            <NavLink
              to="analyse"
              className={({ isActive }) => `${styles.tab} ${isActive ? styles.activeTab : ''}`}
            >
              Analyse
            </NavLink>
          </div>
          <div className={styles.selects}>
            <div className={styles.field}>
              <FilterSearchParam
                label='Région'
                name='region'
                className='block'
                options={list?.regions || []}
              />
            </div>
            <ButtonExport
              type="export"
              onClick={handleDownloadXlsx}
              isLoading={isDownloadingXlsx}
            />
          </div>
        </div>
      </header>

      <div className={styles.subPage}>
        <Outlet />
      </div>
    </div>
  </div>
  );
};

export default Statistiques;
